export default __webpack_public_path__ + "static/media/pokemon.48212ed0.png";